<div class="hexagons-wrap">
  <rt-impact-tracker-hexagons />
</div>

<div class="content">
  <div class="header">
    <div layout layout-vertical>
      <rt-impact-tracker-logo [logoHeading]="logoHeading()" />
      <ng-content select="[headingText]" />
    </div>

    <div class="cta">
      <ng-content select="[cta]" />
    </div>
  </div>

  <div>
    <div class="heading">{{ subheading() }}</div>

    <div class="insights-wrap">
      <ng-content select="[insights]" />
    </div>
  </div>
</div>
